import { useIdentifyAnalyticsUser } from 'src/utils/logger/identifyAnalyticsUser';
import { useIdentifyLaunchDarklyUser } from 'src/utils/logger/identifyLaunchDarklyUser';
import { useIdentifyObservabilityUser } from 'src/utils/logger/identifyObservabilityUser';

import useAuth from './useAuth';

export * from 'src/constants/logger';

/**
 * Hook to setup user identities in all of our telemetry systems.
 * Must be called within a child of AuthProvider and CookieConsentProvider.
 */
const useIdentifyLoggers = () => {
  const { userInfo } = useAuth();
  useIdentifyLaunchDarklyUser(userInfo);
  useIdentifyObservabilityUser(userInfo);
  useIdentifyAnalyticsUser(userInfo);
};

export default useIdentifyLoggers;
